import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {UrlService} from './url.service';

@Injectable({
  providedIn: 'root'
})
export class HealthAPIService {

  private healthApiUrl: string | undefined;
  constructor(public http: HttpClient, private urlService: UrlService) {
  }

  public getAPIHealthCheck(): Observable<string> {
    const url = `${this.urlService.getApiUrl()}/APIHealthCheck`;
    return this.http
      .request('GET', url, {
        responseType: 'text',
      })
      .pipe(map((response: any) => {
        return response;
      }));
  }
}
